import React from 'react';
import PropTypes from 'prop-types';
import Video from './video.styles';

const InlineVideo = ({ mp4Src, webmSrc, thumbnailSrc, attributes }) => (
  <Video
    poster={thumbnailSrc}
    playsInline
    autoPlay
    loop='loop'
    muted
    width='100%'
    height='100%'
    {...attributes}>
    {mp4Src ? <source src={mp4Src} type='video/mp4' /> : null}
    {webmSrc ? <source src={webmSrc} type='video/mp4' /> : null}
  </Video>
);

InlineVideo.propTypes = {
  attributes: PropTypes.shape({}),
  mp4Src: PropTypes.string,
  thumbnailSrc: PropTypes.string,
  webmSrc: PropTypes.string,
};

InlineVideo.defaultProps = {
  attributes: {},
  mp4Src: '',
  thumbnailSrc: '',
  webmSrc: '',
};

export default InlineVideo;
